module.exports = __webpack_public_path__ + "img/IMG_6119.fd30dbf4.jpg";